import React, { useEffect, useContext, useState } from "react";
// import Progress from "../Progress";
import "../ContentPages/style.css";
import SubmitButton from "../Buttons/SubmitButton";
import BackButton from "../Buttons/BackButton";
import { SubmitHandler, useForm } from "react-hook-form";
import { AppContext } from "../../contexts/AppContext";
import {
  initiateApplication,
  updateApplication,
} from "../../Services/applicationService"; // import the save function
import { getCountries } from "../../Services/metadataService.jsx";
import FieldError from "../FieldError/index.jsx";
import { toTitleCase } from "../../Utils/stringHandler.tsx";
import { calculateAge } from "../../Services/localStorage.tsx"; // Assuming you have a utility function for calculating age
import AgeWarningModal from "../Popups/AgeWarningModal/index.jsx";
import { redirectToRealMe } from "../../Services/apiService.jsx";
import Loader from "../Loader/Loader.jsx";
import FloatingTextField from "../FormFields/FloatingTextField.tsx";
import FloatingSelectField from "../FormFields/FloatingSelectField.tsx";
import FloatingDateField from "../FormFields/FloatingDateField.tsx";
import Calendar from "../../assets/images/Calendar.svg";
import max from "lodash-es/max.js";

export interface ImmigrationFormData {
  givenName?: string; // Optional, as per "leave blank if one name"
  surname: string;
  dateOfBirth: string;
  placeOfBirth: string;
  country: string;
  passportNumber?: string;
  issuingCountry?: string;
  visaNumber?: string;
  gender?: string; // Optional or "" for default
}

interface Country {
  dia_countryid: string;
  Name: string;
  Statecode: number;
  "ISO code": string;
}

const Immigration = ({ handleNext, handleBack }) => {
  const { appState, setAppState, userFlows, setUserFlows } =
    useContext(AppContext);
  const [countries, setCountries] = useState<Country[]>([]);
  const [showAgeModal, setShowAgeModal] = useState(false);
  const [pendingData, setPendingData] = useState({});
  const [loading, setLoading] = useState(false);

  const {
    register,
    control,
    handleSubmit,
    formState: { errors, isValid },
    reset,
    watch,
  } = useForm<ImmigrationFormData>({
    mode: "onTouched",
  });

  const selectedCountry = watch("country") || "";
  const issuingCountry = watch("issuingCountry") || "";
  const gender = watch("gender") || "";

  useEffect(() => {
    console.log("Selected country:", selectedCountry);
  }, [selectedCountry]);

  useEffect(() => {
    const applicant = appState?.requestPayload?.applicant;
    const event = appState?.requestPayload?.eventTypeSearch?.[0];
    const supporting = appState?.requestPayload?.supportingInformation;

    console.log("Applicant: from immigration", applicant);
    console.log("Event:", event);

    getCountries()
      .then((meta) => {
        const parsed = JSON.parse(meta.countries || "[]") as Country[];

        let filtered = parsed.filter((c) => c.Statecode === 0);

        let ordered = [
          ...filtered.filter((c) => c.Name === "New Zealand"),
          ...filtered.filter((c) => c.Name !== "New Zealand"),
        ];

        let unique: Country[] = Array.from(
          new Map(ordered.map((c) => [c.dia_countryid, c])).values()
        );

        setCountries(unique);
        if (applicant || event) {
          reset({
            givenName: toTitleCase(applicant?.givenNames) || "",
            surname: toTitleCase(applicant?.familyName) || "",
            dateOfBirth: applicant?.dateOfBirth || "",
            placeOfBirth: toTitleCase(applicant?.placeOfBirth || ""),
            country: applicant?.countryOfBirthId || "",
            passportNumber: event?.documentNumber || "",
            visaNumber: supporting?.inzVisaNumber || "",
            issuingCountry: event?.countryOfEventId || "",
            gender: applicant?.genderId,
          });
        }
      })
      .catch((err) => console.error("Failed to load country list", err));
  }, [appState, reset]);

  //  const calculateAge = (dob) => {
  //     const birth = new Date(dob);
  //     const now = new Date();
  //     let age = now.getFullYear() - birth.getFullYear();
  //     const m = now.getMonth() - birth.getMonth();
  //     if (m < 0 || (m === 0 && now.getDate() < birth.getDate())) age--;
  //     return age;
  //  };
  const onSubmit: SubmitHandler<ImmigrationFormData> = (data) => {
    const age = calculateAge(data.dateOfBirth);
    if (age < 14) {
      setPendingData(data);
      setShowAgeModal(true);
      setUserFlows({
        ...userFlows,
        showLiveness: false,
        childApplication: true,
      });
      return;
      // saveApplication(data, "fee0075c-6dcd-ef11-b8e9-00224891c497");
    } else {
      saveApplication(data, "dee0075c-6dcd-ef11-b8e9-00224891c497");
    }
  };

  const handleAgeModalCancel = () => {
    redirectToRealMe();
  };

  const handleAgeModalContinue = () => {
    setShowAgeModal(false);
    if (pendingData) {
      saveApplication(pendingData, "fee0075c-6dcd-ef11-b8e9-00224891c497");
    }
  };

  const saveApplication = (
    data: ImmigrationFormData,
    applicationTypeId: string
  ) => {
    setLoading(true);
    setUserFlows((prev: any) => ({
      ...prev,
      showRefree: prev.isRenew ? false : true,
    }));

    const updatedAppState = {
      ...appState,
      requestPayload: {
        ...appState.requestPayload,
        applicationTypeId: applicationTypeId,
        applicationFlowCode: 100000000,
        applicant: {
          ...appState.requestPayload.applicant,
          givenNames: toTitleCase(data.givenName || ""),
          familyName: toTitleCase(data.surname),
          dateOfBirth: data.dateOfBirth,
          placeOfBirth: toTitleCase(data.placeOfBirth),
          countryOfBirthId: data.country,
          genderId: data.gender,
          namesKnownAs: [
            {
              nameTypeId: "3ecbc107-c3b8-e911-a866-000d3ae10c61",
              familyName: toTitleCase(data.surname),
              givenNames: toTitleCase(data.givenName || ""),
            },
          ],
        },
        supportingInformation: {
          inzVisaNumber: data.visaNumber,
        },
        eventTypeSearch: [
          {
            eventTypeId: "b9294e90-bcd5-ee11-904c-000d3acb9d09",
            documentNumber: data.passportNumber,
            familyName: toTitleCase(data.surname || "").slice(0, 100),
            givenNames: toTitleCase(data.givenName || "").slice(0, 100),
            dateOfBirth: data.dateOfBirth,
            placeOfBirth: toTitleCase(data.placeOfBirth),
            countryOfBirthId: data.country,
            countryOfEventId: data.issuingCountry,
            genderId: data.gender,
          },
        ],
      },
    };
    // console.log("Updated Application State:", updatedAppState);
    if (updatedAppState.requestPayload.applicationId) {
      updateApplication(updatedAppState.requestPayload)
        .then((response) => {
          console.log("Application updated successfully:", response);
          setAppState(updatedAppState);
          handleNext();
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error initiating application:", error);
          setLoading(false);
        });
    } else
      initiateApplication(updatedAppState.requestPayload)
        .then((response) => {
          console.log("Application initiated successfully:", response);
          updatedAppState.requestPayload.applicationId = response.serviceId;
          setAppState(updatedAppState);
          handleNext();
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error initiating application:", error);
          setLoading(false);
        });
  };

  const onClose = () => {
    setShowAgeModal(false);
  };

  return (
    <>
      {loading && <Loader />}
      {/* <Progress step={2} /> */}
      {showAgeModal && (
        <AgeWarningModal
          onContinue={handleAgeModalContinue}
          onCancel={handleAgeModalCancel}
          onClose={onClose}
          extraLine="In some cases, you may also need an identity referee to confirm your details."
        />
      )}
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="intro">
          <h1 className="intro-title-mi" lang="mi-NZ">
            Kōrero mai ko wai koe
          </h1>
          <hr />
          <h1 className="intro-title">Tell us who you are</h1>

          <div className="step-container">
            <h2 className="step-title mb-2">
              Your details when you entered New Zealand
            </h2>
            <p className="mb-4">
              Enter the details exactly as they appeared on your official travel
              documents when you entered NZ.
              <br />
              For example, your passport, visa, or immigration documentation.
            </p>
            <FloatingTextField
              name="givenName"
              label="Given name(s)"
              inputProps={register("givenName", {
                validate: (value) => {
                  console.log("Validate called for givenName:", value);
                  return (
                    !value ||
                    value?.trim().length < 199 ||
                    "Given name(s) must be less than 198 characters."
                  );
                },
              })}
              error={errors.givenName}
            />
            <p className="mb-4" style={{ fontSize: 14 }}>
              If you have one name, enter it as your surname or family name.
            </p>
            <FloatingTextField
              name="surname"
              label="Surname or family name"
              required
              inputProps={register("surname", {
                required:
                  "If you have one name, please enter it in surname or family name, and leave Given name(s) blank.",
                validate: (value) => {
                  console.log("Validate called for givenName:", value);
                  return (
                    !value ||
                    value?.trim().length < 85 ||
                    "Surname or family name must be less than 84 characters."
                  );
                },
              })}
              error={errors.surname}
            />
            <FloatingDateField
              name="dateOfBirth"
              label="Date of birth (dd/mm/yyyy)"
              control={control}
              calendarIcon={Calendar}
              required
              error={errors.dateOfBirth}
            />
            <FloatingTextField
              name="placeOfBirth"
              label="Place of birth (town/city)"
              required
              inputProps={register("placeOfBirth", {
                required: "This field is required",
                validate: (value) => {
                  console.log("Validate called for givenName:", value);
                  return (
                    !value ||
                    value?.trim().length <= 100 ||
                    "Place of birth must be less than or equal to 100 characters."
                  );
                },
              })}
              error={errors.placeOfBirth}
            />
            <FloatingSelectField
              name="country"
              label="Country of birth"
              required
              register={register}
              value={selectedCountry}
              options={countries.map((c) => ({
                value: c.dia_countryid,
                label: c.Name,
              }))}
              error={errors.country}
            />
            {selectedCountry !== "18ebb77f-2341-e911-a85e-000d3ae0eb6e" &&
              selectedCountry !== "20ebb77f-2341-e911-a85e-000d3ae0eb6e" &&
              selectedCountry !== "0eeab77f-2341-e911-a85e-000d3ae0eb6e" &&
              selectedCountry !== "e6ebb77f-2341-e911-a85e-000d3ae0eb6e" &&
              selectedCountry !== "" && (
                <React.Fragment>
                  <FloatingTextField
                    name="passportNumber"
                    label="Current Passport number"
                    required
                    inputProps={register("passportNumber", {
                      required: "This field is required",
                      pattern: {
                        value: /^[A-Za-z0-9]{6,10}$/,
                        message: "Invalid passport number",
                      },
                    })}
                    error={errors.passportNumber}
                  />
                  <FloatingSelectField
                    name="issuingCountry"
                    label="Issuing country"
                    required
                    register={register}
                    value={issuingCountry}
                    options={countries.map((c) => ({
                      value: c.dia_countryid,
                      label: c.Name,
                    }))}
                    error={errors.issuingCountry}
                  />
                  {issuingCountry !== "92e9b77f-2341-e911-a85e-000d3ae0eb6e" &&
                    issuingCountry !== "" && (
                      <FloatingTextField
                        name="visaNumber"
                        label="NZ immigration visa number"
                        required
                        inputProps={register("visaNumber", {
                          required: "This field is required",
                        })}
                        error={errors.visaNumber}
                      />
                    )}
                </React.Fragment>
              )}
            <FloatingSelectField
              name="gender"
              label="Gender"
              required
              register={register}
              value={gender}
              options={[
                {
                  value: "dcd24bf2-7a1f-e911-a849-000d3ae0b82e",
                  label: "Male",
                },
                {
                  value: "c77f9cf8-7a1f-e911-a849-000d3ae0b82e",
                  label: "Female",
                },
                {
                  value: "353656ca-3820-e911-a853-000d3ae0a6cf",
                  label: "Non-binary",
                },
              ]}
              error={errors.gender}
            />
            {gender === "353656ca-3820-e911-a853-000d3ae0a6cf" ? (
              <FieldError
                error={null}
                info={
                  "Other agencies that use RealMe may record your gender as Other, due to system conditions."
                }
              />
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="step-button-container">
          <SubmitButton
            text={"Save and continue"}
            type="submit"
            onClick={() => {}}
            disabled={!isValid}
          />
          <BackButton text={"Back"} onClick={handleBack} />
        </div>
      </form>
    </>
  );
};

export default Immigration;
